module.exports = __webpack_public_path__ + "img/img-3-mobile.d56223f7.png";